import { DayjsFormats } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { Box, EmptyCell, Typography, type IColumn } from 'shared/ui'
import { type RowGroupInbox } from 'entities/Inbox/model/Table/RowGroupInbox'
import styles from './styles.module.scss'
import { MembersCell } from './MembersCell'

export const getGroupInboxesColumns = (): IColumn<RowGroupInbox>[] => [
  {
    field: 'name',
    name: 'Name',
    isSortable: true,
    renderRowCell: (row) => <NameCell row={row} />,
  },
  {
    field: 'members',
    name: 'Inboxes',
    maxWidth: '320px',
    isSortable: true,
    renderRowCell: (row) => <MembersCell members={row.members} visibleItemsCount={1} />,
  },
  {
    field: 'created_at',
    name: 'Created at',
    isSortable: true,
    renderRowCell: (row) =>
      row.createdAt ? (
        <Typography variant='body-md-regular' ariaLabel='createdAt'>
          {uiStore.dayjs(row.createdAt).format(DayjsFormats.full6)}
        </Typography>
      ) : (
        <EmptyCell />
      ),
  },
]

const NameCell = ({ row }: { row: RowGroupInbox }) => {
  const count = row.inboxesCount
  return (
    <Box
      display='flex'
      justifyContent='space-between'
      alignItems='center'
      gap='4px'
      margin='10px 0'
    >
      <div className={styles.cellWrapper}>
        <Typography
          variant='body-md-regular'
          ariaLabel='inboxName'
          ellipsis
          tooltipProps={{
            label: row.origin.name,
          }}
        >
          {row.origin.name}
        </Typography>
        <Typography variant='body-sm-regular' ariaLabel='numbersCount' color='tertiary'>
          {count} inbox{count > 1 ? 'es' : ''}
        </Typography>
      </div>
    </Box>
  )
}
